module.exports = __webpack_public_path__ + "assets/alert-info-icon.92e1b678.svg";